import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lifestyle-rewards-version-two',
  templateUrl: './lifestyle-rewards.component.html',
  styleUrls: ['./lifestyle-rewards.component.scss']
})
export class LifestyleRewardsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
